import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import './Modal.css';

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  icon: Icon, 
  iconColor = 'cyan', // cyan, orange, red, green
  theme = 'premium', // premium, dark
  children, 
  footer
}) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="appointment-modal-overlay global-modal-overlay" onClick={onClose}>
      <div 
        className={`appointment-modal-container ${theme === 'premium' ? 'glass-modal-premium' : 'dark-modal'}`} 
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <div className={`appointment-modal-header ${theme === 'premium' ? 'premium-header' : ''}`}>
          <div className="header-title">
            {Icon && (
              <div className={`title-icon-wrapper ${iconColor}`}>
                <Icon size={20} />
              </div>
            )}
            <span id="modal-title">{title}</span>
          </div>
          <button 
            className="btn-close-modal" 
            onClick={onClose}
            aria-label="Cerrar ventana modal"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="appointment-modal-body">
          {children}
        </div>
        
        {footer && (
          <div className="appointment-modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
